import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SurveyWorkplaceOption, SurveyWorkplaceSelection } from '../../model/survey';
import { Constant } from '../../constant';

@Component({
  selector: 'app-survey-workplace-select-dialog',
  templateUrl: './survey-workplace-select-dialog.component.html',
  styleUrl: './survey-workplace-select-dialog.component.css',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
  ]
})
export class SurveyWorkplaceSelectDialogComponent {
  @ViewChild('dialogContent') private dialogContent?: ElementRef<HTMLElement>;

  public readonly Constant = Constant;

  public options: SurveyWorkplaceOption[];
  public selection: SurveyWorkplaceSelection;

  constructor(
    private dialogRef: MatDialogRef<SurveyWorkplaceSelectDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: { options: SurveyWorkplaceOption[]; selection: SurveyWorkplaceSelection },
  ) {
    this.options = data.options ?? [];
    this.selection = {
      workplaceId: data.selection?.workplaceId ?? null,
      workplacePath: data.selection?.workplacePath ?? '',
      scopeType: data.selection?.scopeType ?? null,
      partMemberCount: data.selection?.partMemberCount ?? '',
      partName: data.selection?.partName ?? '',
    };
  }

  onSelectWorkplace(option: SurveyWorkplaceOption): void {
    this.selection.workplaceId = option.id;
    this.selection.workplacePath = option.path;
  }

  onScopeTypeChange(): void {
    if (this.selection.scopeType === 'part') {
      // 「選択した職場の一部」を選ぶと下部に入力項目が追加表示されるため、
      // 描画が終わってから見えるよう自動スクロールする
      setTimeout(() => {
        const el = this.dialogContent?.nativeElement;
        if (el) {
          el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
        }
      });
    } else {
      // 「選択した職場そのもの」に戻した場合、以前入力した一部情報を持ち越して送信しない
      this.selection.partMemberCount = '';
      this.selection.partName = '';
    }
  }

  onOnlyNumber(event: any): void {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    this.selection.partMemberCount = event.target.value;
  }

  isValid(): boolean {
    if (this.selection.workplaceId == null || this.selection.scopeType == null) {
      return false;
    }
    if (this.selection.scopeType === 'part') {
      return !!this.selection.partMemberCount && !!this.selection.partName.trim();
    }
    return true;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onGoToProfile(): void {
    this.dialogRef.close();
    this.router.navigate(['/profile']);
  }

  onSelect(): void {
    if (!this.isValid()) {
      return;
    }
    this.dialogRef.close(this.selection);
  }
}
